import React, {useContext} from 'react';
import {Text, TouchableOpacity, View} from 'react-native';
import {ThemeContext} from '../contexts/ThemeContext';

const RadioButton = ({
  text,
  selected,
  disabled,
  onPress,
  style,
  ...props
}) => {
  const theme = useContext(ThemeContext);

  return (
    <TouchableOpacity
      onPress={onPress}
      disabled={disabled}
      style={[
        {
          flexDirection: 'row',
          gap: 12,
        },
        ...(style && style.length ? style || [] : [style]),
      ]}
      {...props}
    >
      <View
        style={[
          {
            width: 20,
            height: 20,
            borderRadius: 10,
            borderWidth: 2,
            borderColor: theme.inputBorderColor,
            backgroundColor: theme.inputBackgroundColor,
            alignItems: 'center',
            justifyContent: 'center',
          },
          disabled ? {opacity: 0.5} : {},
        ]}
      >
        {selected && (
          <View
            style={[
              {
                width: 12,
                height: 12,
                borderRadius: 8,
                backgroundColor: theme.colorPrimary,
              },
              disabled ? {opacity: 0.5} : {},
            ]}
          />
        )}
      </View>

      <Text style={{color: theme.textPrimary}}>
        {text}
      </Text>
    </TouchableOpacity>
  );
};

export default RadioButton;
